import { DeprecatedIcon, Cell } from '@vinted/web-ui';
import { jsx as _jsx } from "react/jsx-runtime";

const UserInfoBlock = _ref => {
  let {
    children,
    iconName,
    iconColor = DeprecatedIcon.Color.GreyscaleLevel4,
    testId
  } = _ref;
  return /*#__PURE__*/_jsx(Cell, {
    styling: Cell.Styling.Tight,
    testId: testId,
    prefix: /*#__PURE__*/_jsx(DeprecatedIcon, {
      name: iconName,
      size: DeprecatedIcon.Size.Small,
      color: iconColor,
      aria: {
        'aria-hidden': 'true'
      }
    }),
    children: children
  });
};

export default UserInfoBlock;